import { render, staticRenderFns } from "./GiteeGistSyncModal.vue?vue&type=template&id=79c09494&"
import script from "./GiteeGistSyncModal.vue?vue&type=script&lang=js&"
export * from "./GiteeGistSyncModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteeGistSyncModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteeGistSyncModal.vue
// module id = 2361
// module chunks = 1